/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import React from 'react';

import { ExpiryStatus } from 'client-code/vod-browse';

import { TiVoMemo } from '../../../core/tivo/tivo-react-wrapper';
import { Mousetrap, ProgressBar } from '../../common';

export const LEFT_QUOTE = String.fromCharCode(8216);
export const RIGHT_QUOTE = String.fromCharCode(8217);
export const SPACED_DASH = ' - ';

interface VodListItemProps {
    item: any;
    index: number;
    isSelected: boolean;
    ghostMode: boolean;
}

const VodListItem: React.FC<VodListItemProps> = ({ item, index, isSelected, ghostMode }) => {
    const getSuffixTitle = (vodItem: any): string => {
        if (vodItem?.vodItemType?.includes('Movie') || vodItem?.vodItemType?.includes('movie')) {
            return vodItem.movieYear ? ` (${vodItem.movieYear})` : '';
        }
        if (
            vodItem?.vodItemType?.includes('Episode') ||
            vodItem?.vodItemType?.includes('episode')
        ) {
            const season = vodItem?.seasonNumber ? `S${vodItem?.seasonNumber}` : '';
            const episode = vodItem?.episodeNumber ? `E${vodItem?.episodeNumber}` : '';
            const episodeTitle = vodItem?.episodeTitle
                ? ` ${LEFT_QUOTE}${vodItem?.episodeTitle}${RIGHT_QUOTE}`
                : '';
            return episodeTitle ? `${SPACED_DASH}${season} ${episode} ${episodeTitle}` : '';
        }
        return '';
    };

    const getExpiryStatus = (expiryStatus?: ExpiryStatus): string => {
        if (!expiryStatus) return '';

        const expiryClassMap: Record<ExpiryStatus, string> = {
            [ExpiryStatus.ExpiresIn24Hours]: 'entitlement-expiry-24-hours',
            [ExpiryStatus.ExpiresIn72Hours]: 'entitlement-expiry-72-hours',
        };

        return expiryClassMap[expiryStatus] || '';
    };

    return (
        <Mousetrap
            value={`${index}_list-view`}
            key={`${item.id}-${index}`}
            className={`list-item${isSelected ? ` focused${ghostMode ? ' ghostHighlight' : ''}` : ''}`}
        >
            <div>
                <span className="title">
                    {item.title}
                    {getSuffixTitle(item)}
                </span>
            </div>
            <span className="list-item-icons">
                {item && item?.percentWatched > 0 && (
                    <div className="list-item-details">
                        <ProgressBar percentage={item.percentWatched} />
                    </div>
                )}
                <span className={`icon-expiry ${getExpiryStatus(item.expiryStatus)}`} />
            </span>
        </Mousetrap>
    );
};

export default TiVoMemo(VodListItem);
